<template lang="pug">
div
  select(v-model="value")
    option(v-for="o in folderPaths", :value="o.folder", :key="Id(o)") {{o.path}}
</template>


<script lang="ts">
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Store } from "@/store";
import { foldersIn, IBookmarkFolder, BookmarkEntry } from "@/modules/BookMarkModule";

@Component
export default class FolderSelectorComponent extends Vue {
  @Prop({ required: true })
  folder!: IBookmarkFolder

  @Prop({ required: true })
  root!: IBookmarkFolder

  @Prop({ required: true })
  exclude!: BookmarkEntry

  get value() {
    return this.folder
  }

  set value(f: IBookmarkFolder) {
    this.$emit('change', f)
  }

  get folderPaths() {
    return foldersIn(this.root, this.exclude)
  }
}
</script>


<style lang="scss" scoped>
// select {
//   max-width: 8em;
//   direction: rtl;
// }
</style>